import type { ComponentType } from "react";
import IntroScreen from "./screens/IntroScreen";
import ChoiceScreen from "./screens/ChoiceScreen";
import CityScreen from "./screens/CityScreen";
import BirthdayScreen from "./screens/BirthdayScreen";
import StatementScreen from "./screens/StatementScreen";
import HowItWorksScreen from "./screens/HowItWorksScreen";
import PlansScreen from "./screens/PlansScreen";
import EventsScreen from "./screens/EventsScreen";
import AuthScreen from "./screens/AuthScreen";
import ContactScreen from "./screens/ContactScreen";
import WelcomeScreen from "./screens/WelcomeScreen";
import type { ScreenComponentProps, ScreenKind } from "./types";

/**
 * Screen kind → component. The runner never imports a screen directly, so
 * adding a kind is one file plus one line here, and an experiment can render
 * a brand-new screen type without touching the runner.
 */
export const SCREEN_REGISTRY: Record<
  ScreenKind,
  ComponentType<ScreenComponentProps<any>>
> = {
  intro: IntroScreen,
  choice: ChoiceScreen,
  city: CityScreen,
  birthday: BirthdayScreen,
  statement: StatementScreen,
  howItWorks: HowItWorksScreen,
  plans: PlansScreen,
  events: EventsScreen,
  auth: AuthScreen,
  contact: ContactScreen,
  welcome: WelcomeScreen,
};
